import { Button } from "antd";
import React from "react";
import { AdStatus } from "../../../../../models";
import styles from "../adCard.scss"
import { EditIcon } from "./EditIcon";

export const EditButton = ({ ad, adActions }) => {

  const expiringSoonDisabled = ad.status === AdStatus.sold || ad.status === AdStatus.expired

  const defaultDisabled = ad.status === AdStatus.sold


  return (
    <React.Fragment>

      {ad.expiringSoon ? (
        ad.status === AdStatus.paused ? null : (
          <Button
            className={styles.button}
            disabled={expiringSoonDisabled}
            onClick={adActions.onEdit}
            style={{ height: 38, background: "#ebebeb" }}
          >
            <EditIcon className={`${styles.editIcon} ${expiringSoonDisabled ? styles.disabled : ""}`} />
            Uredi oglas
          </Button>
        )
      ) : (
        <Button
          className={styles.button}
          disabled={defaultDisabled}
          onClick={adActions.onEdit}
          style={{ height: 38, background: "#ebebeb" }}
        >
          <EditIcon className={`${styles.editIcon} ${defaultDisabled ? styles.disabled : ""}`} />
          Uredi oglas
        </Button>
      )}
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/AdCardActions/EditButton.tsx